import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type EditTransactionDTO = {
    shipping_status:string
};

type TransactionResponse  = object & ApiError;

export const EditTransaction = (data: EditTransactionDTO , id:string): Promise<TransactionResponse> => {
    return axios.patch(`/transaction/${id}`, data)
        .then(response => response.data as TransactionResponse);
};